import React from 'react';
import styled from 'styled-components';
import { CTALink } from '../Link';
import { RichH1 } from '../Typography';
import { RichTextWithAnchor } from '../Typography/RichText';
import media from '../../utils/media';
import { isFieldValid, isValidType } from '../../utils/validation';
// TODO: consolidate InfographicText and TextBox to one component
const Container = styled.section `
  outline: none;
  width: calc(100% - 330px);
  background-color: #ffffff;
  position: relative;
  margin: 80px 165px 100px;

  ${media.mobile} {
    width: 100%;
    margin: 40px auto 30px;
    padding: 0px 36px;
  }
`;
const Title = styled(RichH1) `
  margin-bottom: 20px;

  ${media.mobile} {
    margin-bottom: 10px;
  }
`;
const RichTextContainer = styled.div `
  margin-bottom: 20px;
`;
export const FreeFormText = ({ fields }) => {
    if (!fields) {
        return null;
    }
    const { ctaLink, ctaLinkText, ctaType, textBoxBodyText, textBoxTitle, ariaLabel } = fields;
    return (React.createElement(Container, { "aria-label": ariaLabel && ariaLabel.value },
        isFieldValid(textBoxTitle) && React.createElement(Title, { field: textBoxTitle }),
        isFieldValid(textBoxBodyText) && isValidType(textBoxBodyText, 'string') && (React.createElement(RichTextContainer, null,
            React.createElement(RichTextWithAnchor, { field: textBoxBodyText }))),
        isFieldValid(ctaLink, 'href') && isFieldValid(ctaLinkText) && (React.createElement(CTALink, { field: ctaLink, textField: ctaLinkText, typeField: ctaType }))));
};
